// One icon system for the marketing page: 24-unit grid, 1.6px round strokes.

const base = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
};

const Svg = ({ size, children, ...rest }) => (
  <svg {...base} {...(size ? { width: size, height: size } : {})} {...rest}>
    {children}
  </svg>
);

export const IconBag = (p) => (
  <Svg {...p}>
    <path d="M6 8h12l1 12H5L6 8Z" />
    <path d="M9 8V6a3 3 0 0 1 6 0v2" />
  </Svg>
);

export const IconMail = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="m4 7 8 6 8-6" />
  </Svg>
);

export const IconDownload = (p) => (
  <Svg {...p}>
    <path d="M12 4v11" />
    <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
    <path d="M4.5 19.5h15" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </Svg>
);

export const IconArrow = (p) => (
  <Svg {...p}>
    <path d="M4.5 12h15" />
    <path d="m13.5 6 6 6-6 6" />
  </Svg>
);

export const IconChevron = (p) => (
  <Svg {...p}>
    <path d="m6 9 6 6 6-6" />
  </Svg>
);

export const IconExternal = (p) => (
  <Svg {...p}>
    <path d="M14 4.5h5.5V10" />
    <path d="M19.5 4.5 11 13" />
    <path d="M18 14v5.5H4.5V6H10" />
  </Svg>
);

export const IconKey = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="14.5" r="4" />
    <path d="m11 11.5 8.5-8.5" />
    <path d="M16 7l2.5 2.5M18.5 4.5 21 7" />
  </Svg>
);

export const IconClock = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Svg>
);

export const IconShield = (p) => (
  <Svg {...p}>
    <path d="M12 3.5 5 6.5v5c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9v-5l-7-3Z" />
    <path d="m9 12 2 2 4-4" />
  </Svg>
);

export const IconStamp = (p) => (
  <Svg {...p}>
    <path d="M9 11V7a3 3 0 0 1 6 0v4" />
    <path d="M5 11h14l1 5H4l1-5Z" />
    <path d="M6 20h12" />
  </Svg>
);

export const IconBan = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="m6 6 12 12" />
  </Svg>
);

export const IconMenu = (p) => (
  <Svg {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const IconClose = (p) => (
  <Svg {...p}>
    <path d="m6 6 12 12M18 6 6 18" />
  </Svg>
);

export const IconFile = (p) => (
  <Svg {...p}>
    <path d="M7 3.5h7l4 4v13H7v-17Z" />
    <path d="M14 3.5v4h4" />
  </Svg>
);

export const IconCloud = (p) => (
  <Svg {...p}>
    <path d="M7.5 18.5a4 4 0 0 1-.6-7.95A5.5 5.5 0 0 1 17.6 9.6 3.75 3.75 0 0 1 17 18.5h-9.5Z" />
  </Svg>
);

export const IconGlobe = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17M12 3.5c2.5 2.6 3.75 5.4 3.75 8.5S14.5 17.9 12 20.5c-2.5-2.6-3.75-5.4-3.75-8.5S9.5 6.1 12 3.5Z" />
  </Svg>
);

export const IconStar = ({ size = 16, ...p }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...p}
  >
    <path d="M12 2.8l2.85 5.9 6.45.9-4.7 4.5 1.15 6.4L12 17.45 6.25 20.5l1.15-6.4-4.7-4.5 6.45-.9L12 2.8Z" />
  </svg>
);

export const Stars = ({ size = 16, label = "Rated 5 out of 5" }) => (
  <span className="lp-stars" role="img" aria-label={label}>
    {[0, 1, 2, 3, 4].map((i) => (
      <IconStar key={i} size={size} />
    ))}
  </span>
);
